const clamp = (minSizePx, maxSizePx, minWidthPx = 375, maxWidthPx = 1440) => {
    const pixelsPerRem = 16;
    const minWidth = minWidthPx / pixelsPerRem;
    const maxWidth = maxWidthPx / pixelsPerRem;
    const minSize = minSizePx / pixelsPerRem;
    const maxSize = maxSizePx / pixelsPerRem;
    const slope = (maxSize - minSize) / (maxWidth - minWidth);
    const yAxisIntersection = -minWidth * slope + minSize;
    const min = `${round(minSize)}rem`;
    const val = `${round(yAxisIntersection)}rem + ${round(slope * 100)}vw`;
    const max = `${round(maxSize)}rem`;
    return `clamp(${min}, ${val}, ${max})`;
};
const round = (num) => {
    return Math.round(num * 100) / 100;
};
export default clamp;
